import styles from "./css/home.module.css"
import { useEffect } from "react";

import ide_logo from "../assets/img/ide.png"


export default function Home({ setHeader }) {

  useEffect(() => {
    setHeader(true);
  }, []);

  return (
    <div className={styles.home}>
      <div className={styles.home__welcome}>
        <div className={styles.logo}>
          <img src={ide_logo} alt="ide logo" />
        </div>
        <h1>Bem-vindo(a)</h1>
        <h4>Ao painel administrativo da IDE Editora</h4>
      </div>
    </div>
  );

}